import { z } from 'zod';

export const ReceiveAllCouponsServiceRequestSchema = z
  .object({
    shopTitle: z.string(),
  })
  .describe('ReceiveAllCouponsServiceRequest');

export type ReceiveAllCouponsServiceRequest = z.infer<typeof ReceiveAllCouponsServiceRequestSchema>;

const FailedCouponResultSchema = z.object({
  couponNo: z.number().int(),
  errorCode: z.string().optional(),
});

export type FailedCouponResult = z.infer<typeof FailedCouponResultSchema>;

export const ReceiveAllCouponsServiceResponseSchema = z
  .object({
    totalCount: z.number().int().nonnegative(),
    successCount: z.number().int().nonnegative(),
    failedCount: z.number().int().nonnegative(),
    successCouponNos: z.array(z.number().int()),
    failedResults: z.array(FailedCouponResultSchema),
  })
  .describe('ReceiveAllCouponsServiceResponse');

export type ReceiveAllCouponsServiceResponse = z.infer<
  typeof ReceiveAllCouponsServiceResponseSchema
>;
